import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {useMediaQuery} from 'react-responsive';
import Navbar from 'components/navbar/Navbar';
import navbarStore from 'components/navbar/NavbarStore';
import Marquee from 'helpers/Marquee';
import Title from 'components/LandingPage/Title';
import {announcement} from 'ferries/Home/content';
import {MOBILE_WIDTH} from 'helpers/stableValues';
import {replaceAssetsImgUrl, calcBackgroundFullWidth} from 'cms/helpers/common';

const Hero = ({isHomePage, title, slogan, heroImage, children}) => {
  const isMobile = useMediaQuery({query: `(max-width: ${MOBILE_WIDTH}px)`});
  const textClass = classNames('text-center', {'mt-6': isMobile,'mt-4': !isMobile});
  const sloganClass = classNames('text-white w-lg-1-2 mx-auto', {'mb-5': isMobile,'mb-8': !isMobile});

  return (
    <section className="section-hero">
      <div className="hero-bg">
        <img
          className="w-1-1 h-1-1 img-cover"
          src={replaceAssetsImgUrl(heroImage, calcBackgroundFullWidth())}
        />
      </div>
      <div className="section-hero-inner">
        <header className="section-hero-header">
          <Navbar navbar={navbarStore} />
          {announcement && <Marquee announcement={announcement} />}
        </header>
        <div className="container">
          <div className={textClass}>
            <Title navbar={navbarStore} isHomePage={isHomePage} title={title} />
            {
              slogan &&
                <p className={sloganClass}>
                  {slogan}
                </p>
            }
          </div>
          {children}
        </div>
      </div>
    </section>
  );
};

Hero.propTypes = {
  isHomePage: PropTypes.bool.isRequired,
  heroImage: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  slogan: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node
  ])
};

Hero.defaultProps = {
  isHomePage: false,
  title: '',
  slogan: ''
};

export default Hero;
